
































import {Component, Prop, Vue} from 'vue-property-decorator'
import ModalPopup from '@/components/dialogs/ModalPopup.vue'
import {panelShare, panelUpdate, ShareMode, ShareRequest} from '@/data/repos/panels'
import Button from '@/components/buttons/Button.vue'
import MultiUserSelect from '@/components/inputs/MultiUserSelect.vue'
import appConfig from '@/config'

@Component({components: {MultiUserSelect, ModalPopup, Button}})
export default class SharePanelPopup extends Vue {
  @Prop({
    default: () => {
      return {}
    },
  })
  public panel: any
  @Prop() public canEdit!: boolean
  @Prop() public canShare!: boolean
  private progress = false
  private panelName: string = ''
  public ShareModes = ShareMode
  private shareMode: ShareMode = ShareMode.private
  public modes = [
    {label: 'Private', mode: ShareMode.private},
    {label: 'Public', mode: ShareMode.public},
    {label: 'Shared with users', mode: ShareMode.users}]
  public sharedWithUsers: number[] = []

  public async created() {
    this.panelName = this.panel.name
    this.sharedWithUsers = this.panel.sharedWithUsers
    this.shareMode = this.panel.share
  }

  public async save() {
    if (this.panelName !== this.panel.name) {
      this.progress = true
      const p = await panelUpdate(this.panel.id, this.panel.userId, this.panelName)
      this.$emit('update:panel', Object.assign({}, this.panel, p))
    }

    const r: ShareRequest = {
      id: this.panel.id,
      share: this.shareMode,
      panelUrl: this.myURL,
      sharedWithUsers: this.sharedWithUsers,
    }
    this.progress = true
    const resp = await panelShare(r)
    this.progress = false
    this.$emit('update:panel', Object.assign({}, this.panel, resp))

    this.progress = false
    this.close()
  }

  private close() {
    this.$emit('close')
  }

  get myURL() {
    return appConfig.BASE_URL + this.$router.currentRoute.fullPath
  }
}
